module.exports = __webpack_public_path__ + "static/media/arrow-down-light.30374ec6.svg";